import { format } from 'date-fns';
import LangEnum from '../../../../lang/LangEnum';
import { localeToDateFns } from '../../../../utils/dates';
import { DateRangeFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { FilterFactoryGetLabelParams, IFilterHelperFactory } from '../filter-factory.types';

class DateRangeFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: DateRangeFilter) {}

  getChipLabel({ locale, translate }: FilterFactoryGetLabelParams) {
    const initialDate = this.filter.dateRangeArgs?.initialDate;
    const finalDate = this.filter.dateRangeArgs?.finalDate;

    if (!initialDate && !finalDate) {
      return '';
    }

    const formatType = 'P';
    const formattedInitialDate =
      initialDate && format(initialDate, formatType, { locale: localeToDateFns[locale] });
    const formattedFinalDate =
      finalDate && format(finalDate, formatType, { locale: localeToDateFns[locale] });

    const titlePrefix = `${this.filter.title}: `;

    if (initialDate && finalDate) {
      return (
        titlePrefix +
        translate(LangEnum.FILTER_DATE_RANGE_FILTERING_BETWEEN, {
          initialDate: formattedInitialDate,
          finalDate: formattedFinalDate,
        })
      );
    }

    if (initialDate) {
      return (
        titlePrefix +
        translate(LangEnum.FILTER_DATE_RANGE_FILTERING_FROM, {
          initialDate: formattedInitialDate,
        })
      );
    }

    return (
      titlePrefix +
      translate(LangEnum.FILTER_DATE_RANGE_FILTERING_UNTIL, {
        finalDate: formattedFinalDate,
      })
    );
  }

  getFriendlyLabel(params: FilterFactoryGetLabelParams): string {
    return this.getChipLabel(params);
  }

  hasValue() {
    return !!this.filter.dateRangeArgs?.initialDate || !!this.filter.dateRangeArgs?.finalDate;
  }

  isLoading() {
    return false;
  }
}

export default DateRangeFilterHelper;
